import { ReactNode } from 'react';
import clsx from 'clsx';
import { LoadingSpinner } from './LoadingSpinner';

export interface SectionCardProps {
  title: string;
  icon?: ReactNode;
  children: ReactNode;
  isLoading?: boolean;
  headerActions?: ReactNode;
  className?: string;
  noPadding?: boolean;
}

export const SectionCard = ({
  title,
  icon,
  children,
  isLoading = false,
  headerActions,
  className,
  noPadding = false,
}: SectionCardProps) => {
  return (
    <div className={clsx('card overflow-hidden', className)}>
      {/* Header */}
      <div className="flex items-center justify-between border-b border-[var(--color-border-light)] px-5 py-4">
        <div className="flex items-center gap-2">
          {icon && (
            <span className="text-[var(--color-text-muted)]">{icon}</span>
          )}
          <h3 className="text-heading-base text-[var(--color-text-primary)]">
            {title}
          </h3>
        </div>
        {headerActions && (
          <div className="flex items-center gap-2">{headerActions}</div>
        )}
      </div>

      {/* Body */}
      <div className={clsx(!noPadding && 'p-5')}>
        {isLoading ? (
          <div className="flex items-center justify-center py-12">
            <LoadingSpinner size="md" />
          </div>
        ) : (
          children
        )}
      </div>
    </div>
  );
};
